<template>
  <div class="all_user_box">
    <!-- <div> -->
      <Select v-model="userInfoId" ref="clear" style="width:170px" placeholder="可模糊查询用户账号" clearable filterable @on-clear="clearUserId" @on-change="changeUserId">
        <Option v-for="item in userList" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    <!-- </div> -->
  </div>
</template>

<script>
import https from '../../https'
export default {
  name: 'esApp',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: true,
      tableLoading: true,
      errorMsg: null,
      userList: [],
      url: {
        appver: 'v2/es/audit/appver/progress'
      }
    }
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.token = https.token
    this.getUserList()
  },
  mounted () {
  },
  methods: {
    changeUserId (val) {
      this.$emit('usernameChange', val)
    },
    clearUserId () {
      this.$emit('usernameChange', '')
    },
    clear () {
      this.userInfoId = ''
      this.$refs.clear.clearSingleSelect()
      console.log(this.userInfoId)
    },
    getUserList () {
      let params = {
        pageSize: 200,
        key: '',
        pageNo: 1
      }
      let url = 'getUsernamesByKey'
      if (this.type === 'all') {
        url = 'getAllUsernamesByKey'
      }
      https.request({
        method: 'get',
        url: url,
        params: params
      }).then(res => {
        res.data.map(item => {
          this.userList.push({
            value: item.value,
            label: item.text
          })
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    show (row, type, time, typeT) {
      // https.request({
      //   method: 'post',
      //   url: url,
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'satoken': https.token
      //   },
      //   data: params
      // }).then(res => {
      // })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .all_user_box{
    width:250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/allUser.vue